// extracted by mini-css-extract-plugin
export var divider = "_q0-0";
export var systemMessage = "_q0-1";
export var systemMessageWrapper = "_q0-2";